export const cookieConsentText =
    'We’d like to use analytics cookies. These collect information about how our site is used and we’ll use this information to improve our site. If you\'d prefer we didn\'t set cookies you can click "I decline"'
